/** @param {import("@nuxtjs/axios").NuxtAxiosInstance} client */
export default (client) => {

  return {
    getGuestUserToken() {
      return client.get('guest')
    },
  }
}
